
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_1xirj_9",
  "input": "awsui_input_1sdq3_1xirj_44",
  "results": "awsui_results_1sdq3_1xirj_48"
};
  